type DeviationDirection = 'up' | 'down' | 'neutral'

export const getRealizedDeviationData = (amount: number, percentage: number) => ({
  amount,
  percentage,
  direction: (amount > 0 ? 'up' : amount < 0 ? 'down' : 'neutral') as DeviationDirection
})
